import {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";

import {useStoredMe} from "@/src/modules/core/store/me";

import {shouldEnforcePropertySetupGate} from "../lib/me-requires-properties";

const PROPERTIES_PATH = "/properties";

function isAllowedPathWhenNoProperties(pathname: string): boolean {
  if (pathname === PROPERTIES_PATH) return true;
  if (pathname === "/location-denied" || pathname === "/acknowledge-shift") return true;
  if (pathname === "/logout" || pathname.endsWith("/logout")) return true;
  return false;
}

/**
 * Redirects property managers with no assigned properties to `/properties` only
 * (plus logout / location-denied / acknowledge-shift).
 */
export default function useRequirePropertiesNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const me = useStoredMe();

  useEffect(() => {
    if (!me) return;

    if (!shouldEnforcePropertySetupGate(me)) return;

    const pathname = location.pathname;
    if (isAllowedPathWhenNoProperties(pathname)) return;

    navigate(`${PROPERTIES_PATH}?newProperty=1`, {replace: true});
  }, [me, location.pathname, navigate]);
}
